import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom';
import LoginPage from './frontend/Login/Login';
import Shows from './admin/Shows/ManageShows'
import Creators from './admin/Creators/ManageCreators'
import AddCreator from './admin/Creators/addCreator';
import AddShow from './admin/Shows/addShow';
import Assets from './admin/Assets/Assets';
import AssetDetails from './admin/Assets/AssetDetails';
import Ingest from './admin/Ingest/Ingest';

ReactDOM.render(
  <Router>
    <Routes>
      <Route exact path='/' element={<LoginPage />}></Route>
      <Route exact path='/login' element={< LoginPage />}></Route>
      <Route exact path='/admin/shows' element={<Shows />}></Route>
      <Route exact path='/admin/shows/:creatorID' element={<Shows />}></Route>
      <Route exact path='/admin/show/add' element={<AddShow />}></Route>
      <Route exact path='/admin/show/edit/:showID' element={<AddShow />}></Route>
      <Route exact path='/admin/creators' element={<Creators />}></Route>
      <Route exact path='/admin/creator/add' element={<AddCreator />}></Route>
      <Route exact path='/admin/creator/edit/:creatorID' element={<AddCreator />}></Route>
      <Route exact path='/admin/assets/:type' element={<Assets />}></Route>
      <Route exact path='/admin/assets/:type/:showID' element={<Assets />}></Route>
      <Route exact path='/admin/assets/details/:assetID' element={<AssetDetails />}></Route>
      <Route exact path='/admin/ingest/view' element={<Ingest />}></Route>
      
    </Routes>
  </Router>,
  document.getElementById('root')
);

reportWebVitals();
